const pacingStyles = {
  english: {
    width: '225px',
    float: 'left',
    top: '17px',
    left: '20px',
    position: 'absolute',
  },
  math: {
    width: '225px',
    float: 'left',
    top: '17px',
    left: '275px',
    position: 'absolute',
  }, 
  reading: {
    width: '225px',
    float: 'left',
    top: '78px',
    left: '20px',
    position: 'absolute',
  },
  science: {
    width: '225px',
    float: 'left',
    top: '78px',
    left: '275px',
    position: 'absolute',
  }
}

export default pacingStyles


// WEBPACK FOOTER //
// ./src/helpers/assessment/pacingStyles.js